import PropTypes from 'prop-types';

function pageContext(shape = {}) {
  return PropTypes.shape({
    id: PropTypes.string.isRequired,
    menus: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        to: PropTypes.string,
        subMenus: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            to: PropTypes.string.isRequired,
          }),
        ),
      }),
    ).isRequired,
    ...shape,
  });
}

const iconCard = PropTypes.shape({
  url: PropTypes.string,
  external: PropTypes.bool,
  icon: PropTypes.shape({
    type: PropTypes.string,
    name: PropTypes.string,
    color: PropTypes.string,
  }).isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
});

const imageCard = PropTypes.shape({
  url: PropTypes.string,
  external: PropTypes.bool,
  image: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
});

const section = PropTypes.shape({
  type: PropTypes.string.isRequired,
  image: PropTypes.object,
  title: PropTypes.string,
  content: PropTypes.string,
  iconCards: PropTypes.arrayOf(iconCard),
  imageCards: PropTypes.arrayOf(imageCard),
});

const sections = PropTypes.arrayOf(section);

function data(shape = {}) {
  return PropTypes.shape({
    page: PropTypes.shape({
      frontmatter: PropTypes.shape({
        uuid: PropTypes.string,
        active: PropTypes.bool,
        lang: PropTypes.string,
        metaTitle: PropTypes.string,
        metaDescription: PropTypes.string,
        name: PropTypes.string,
        sections: sections.isRequired,
        ...shape,
      }).isRequired,
    }),
  });
}

export const propTypes = { data, pageContext, iconCard, imageCard, section, sections };
